import React from 'react'
import { timeLeft, deadlineDate, nextStep, URGENCY_BADGE, KIND_LABEL } from './ebayRequestFormat.js'
import OffOnStaging from '../OffOnStaging'

// Every request open on eBay, soonest deadline first (the worker sorts).
// Spec: docs/specs_20261013_ebay_return_flow.md
function EbayRequestsList({ view, checking = false, onCheckNow, onOpenCase, onCreateCase }) {
  const open = view.requests.filter(request => !request.closed_at)

  return (
    <div className="card" style={{ marginTop: 'var(--space-3)', marginBottom: 'var(--space-4)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 'var(--space-2)', flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0 }}>eBay requests ({open.length})</h3>
        <OffOnStaging feature="ebay">
          <button className="btn btn-sm btn-secondary" onClick={onCheckNow} disabled={checking}>
            {checking ? 'Checking...' : 'Check eBay now'}
          </button>
        </OffOnStaging>
      </div>

      {view.sync.stale && (
        <p role="alert" className="badge badge-error" style={{ marginTop: 'var(--space-2)' }}>
          This list may be out of date. {view.sync.last_error || 'The last check of eBay did not finish.'}
        </p>
      )}

      {open.length === 0 ? (
        <p className="text-muted" style={{ marginTop: 'var(--space-2)' }}>No open requests on eBay.</p>
      ) : (
        <div style={{ overflowX: 'auto', marginTop: 'var(--space-2)' }}>
          <table className="table">
            <thead>
              <tr><th>Due</th><th>Kind</th><th>Buyer</th><th>Item</th><th>Next step on eBay</th><th>Prism case</th><th></th></tr>
            </thead>
            <tbody>
              {open.map(request => (
                <tr key={request.ebay_request_id}>
                  <td><DueCell request={request} /></td>
                  <td>{KIND_LABEL[request.kind]}</td>
                  <td>{request.buyer_username}</td>
                  <td><ItemCell request={request} /></td>
                  <td>{nextStep(request)}</td>
                  <td><CaseCell request={request} onOpenCase={onOpenCase} onCreateCase={onCreateCase} /></td>
                  <td><a href={request.url} target="_blank" rel="noreferrer">Open on eBay</a></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

// The deadline as a date first, in plain text, then how long is left.
function DueCell({ request }) {
  const date = deadlineDate(request.respond_by)
  return (
    <div style={{ whiteSpace: 'nowrap' }}>
      {date && <div style={{ fontWeight: 600 }}>{date}</div>}
      <span className={`badge ${URGENCY_BADGE[request.urgency]}`}>{timeLeft(request.respond_by)}</span>
    </div>
  )
}

// eBay's search rows carry no item title. A linked Prism case has one; without
// a case the row shows eBay's item number. Both link to the listing.
function ItemCell({ request }) {
  const name = request.case_product_title || (request.ebay_item_id ? `eBay item ${request.ebay_item_id}` : null)
  if (!name) return <span className="text-muted">Unknown</span>
  if (!request.item_url) return name
  return <a href={request.item_url} target="_blank" rel="noreferrer">{name}</a>
}

function CaseCell({ request, onOpenCase, onCreateCase }) {
  if (request.return_request_id) {
    return (
      <button className="btn btn-sm btn-secondary" onClick={() => onOpenCase?.(request.return_request_id)}>
        {request.case_public_id || `#${request.return_request_id}`}
      </button>
    )
  }
  if (onCreateCase) {
    return <button className="btn btn-sm btn-primary" onClick={() => onCreateCase(request)}>Create case</button>
  }
  return <span className="text-muted">No Prism case</span>
}

export default EbayRequestsList
